import CloseIcon from '@/components/shared/icons/close-icon';
import { Box, Drawer, IconButton, Typography, useTheme, useMediaQuery } from '@mui/material';

const CustomDrawer = ({ open, title, anchor = 'right', onClose, children, pagerProps }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery('(max-width: 576px)');

    return (
        open && (
            <Drawer
                anchor={anchor}
                open={open}
                onClose={onClose}
                transitionDuration={300}
                PaperProps={{
                    sx: {
                        bgcolor: theme.palette.background.default,
                        height: '100dvh',
                        maxHeight: '100dvh',
                        width: '95%',
                        maxWidth: '600px',
                        ...pagerProps,
                    },
                }}
            >
                {/* Encabezado */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        bgcolor: theme.palette.background.darkCard,
                        padding: isMobile ? '8px' : '16px',
                        position: 'sticky',
                        top: 0,
                        zIndex: 9999,
                        height: '40px',
                        borderBottom: `1px solid ${theme.palette.border.main}`,
                    }}
                >
                    <Typography variant="h6" sx={{ fontWeight: 500 }}>
                        {title}
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon sx={{ color: theme.palette.footer.text }} />
                    </IconButton>
                </Box>

                {/* Contenido Principal */}
                {children}
            </Drawer>
        )
    );
};

export default CustomDrawer;
